// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2RIYC","list":"styles_list__2TRol"};